import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    presupuestoInternoId: 0,
    presupuestoNumero: '',
    cliente: '',
    accion: '',
    clienteContacto: '',
    condicionFiscalId: 0,
    condicionFiscalNombre: null,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    total: 0,
    
    monedaPresupuestoId: 0,
    monedaPresupuestoNombre: null,
    cotizacionPresupuesto: 0,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    cotizacion: 0,

    montoGravado: 0,
    montoExento: 0,
    montoNoGravado: 0,
    montoIvaInscripto: 0,
    observaciones: '',
    renglones: [],
    renglonesDescripcion: [],

    pjeIvaInscripto: 21,
    cotizacionReadOnly: true,

    monedas: [
        { id: 101, nombre: 'PESOS' },
        { id: 102, nombre: 'DOLARES' },
    ],
    monedasList:  ['PESOS', 'DOLARES'],

    facturaProformaDatos: [],
    facturaProformaRenglonesDatos: [],
    facturaProformaRenglonesDescripcionDatos: [],

    facturaProformaDatosPDF: [],
    facturaProformaRenglonesDatosPDF: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_FACTURA' (state, presupuestoId) {
        state.id = 0;
        state.presupuestoInternoId = presupuestoId;
        state.presupuestoNumero = '';
        state.cliente= '';
        state.accion= '';
        state.clienteContacto= '';
        state.condicionFiscalId= 0;
        state.condicionFiscalNombre= null;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD');
        state.formaPagoId= 0;
        state.formaPago= null;
        state.formaPagoNombre= null;
        state.numero = 0;
        state.monedaPresupuestoId = 101;
        state.monedaPresupuestoNombre = 'PESOS';
        state.cotizacionPresupuesto = 1;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.cotizacion = 1;

        state.total = 0;
        state.montoGravado= 0;
        state.montoExento= 0;
        state.montoNoGravado= 0;
        state.montoIvaInscripto= 0;
        state.observaciones = '';
        state.renglones = [];
        state.renglonesDescripcion = [];

        state.cotizacionReadOnly = true;
    },
    'SET_FACTURA' (state, facturaProforma) {
        state.presupuestoNumero = facturaProforma.presupuestoNumero;
        state.cliente= facturaProforma.cliente.trim();
        state.accion= facturaProforma.accion? facturaProforma.accion.trim() : '';
        state.clienteContacto= facturaProforma.clienteContacto? facturaProforma.clienteContacto.trim() : '';
        state.condicionFiscalId= facturaProforma.condicionFiscalId;
        state.condicionFiscal= facturaProforma.condicionFiscal;
        state.condicionFiscalNombre= facturaProforma.condicionFiscal? facturaProforma.condicionFiscal.nombre.trim() : null;
        state.fechaComprobante = moment(facturaProforma.fechaComprobante).format('YYYY-MM-DD');
        state.formaPagoId= facturaProforma.formaPagoId;
        state.formaPago= facturaProforma.formaPago;
        state.formaPagoNombre= facturaProforma.formaPago? facturaProforma.formaPago.nombre.trim() : null;
        state.monedaPresupuestoId = facturaProforma.monedaId;
        state.monedaPresupuestoNombre = facturaProforma.moneda? facturaProforma.moneda.nombre.trim() : null;
        state.cotizacionPresupuesto = facturaProforma.cotizacion;
        state.monedaId = facturaProforma.monedaId;
        state.moneda = facturaProforma.moneda;
        state.monedaNombre = facturaProforma.moneda? facturaProforma.moneda.nombre.trim() : null;
        state.cotizacion = facturaProforma.cotizacion;
        state.observaciones = '';
        
        state.renglones= facturaProforma.renglones.map(renglon => 
            ({ 
                ...renglon, 
                /* Total en la moneda del presupuesto */
                importeNetoPresupuesto: renglon.importeNeto 
            }));
        
        calcularTotalesRenglones(state);
        setRenglonDescripcion(state);
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPagoId = formaPago? formaPago.id : 0;
        state.formaPago = formaPago;
        state.formaPagoNombre = formaPago? formaPago.nombre.trim() : null;
    },
    'UPDATE_PJE_FACTURADO_RENGLON' (state, params) {
        let renglon = state.renglones.find( r => r.ordenTrabajoId == params.ordenTrabajoId);
        if (renglon) {
            renglon.pjeFacturado = parseFloat(params.pjeFacturado);
            renglon.importe =  roundNumber(parseFloat(renglon.importeNeto) * parseFloat(renglon.pjeFacturado) / 100, 2);
        }

        calcularTotalesRenglones(state);
        setRenglonDescripcion(state);
    },
    'UPDATE_IMPORTE_RENGLON' (state, params) {
        let renglon = state.renglones.find( r => r.ordenTrabajoId == params.ordenTrabajoId);
        if (renglon) {
            renglon.importe = parseFloat(params.importe);
            renglon.pjeFacturado = roundNumber(parseFloat(params.importe / renglon.importeNeto * 100), 2);
        }

        calcularTotalesRenglones(state);
        setRenglonDescripcion(state);
    },
    'SET_MONEDA'(state, moneda) {
        state.monedaId = moneda? moneda.id : 0;
        state.moneda = moneda;
        state.monedaNombre = moneda? moneda.nombre.trim() : null;

        if (state.monedaId == 101) {
            if (state.monedaPresupuestoId == 101) {
                state.cotizacion = parseFloat(1);
                state.cotizacionReadOnly = true;
            } else {
                state.cotizacionReadOnly = false;
            }
        } else if (state.monedaId == 102) {
            state.cotizacionReadOnly = false;
        }

        state.renglones.forEach(renglon => {
            /* Actualizamos el importe neto */
            if (state.monedaId == state.monedaPresupuestoId) {
                renglon.importeNeto = renglon.importeNetoPresupuesto;
            } else {
                if (state.monedaId == 102 & state.monedaPresupuestoId == 101) {
                    renglon.importeNeto = roundNumber(parseFloat(renglon.importeNetoPresupuesto) / parseFloat(state.cotizacion), 2);
                } else {
                    renglon.importeNeto = roundNumber(parseFloat(renglon.importeNetoPresupuesto) * parseFloat(state.cotizacion), 2);
                }
            }
            /* Actualizamos el importe facturado */
            renglon.importe =  roundNumber(parseFloat(renglon.importeNeto) * parseFloat(renglon.pjeFacturado) / 100, 2);
        });

        calcularTotalesRenglones(state);
        setRenglonDescripcion(state);
    },
    'UPDATE_COTIZACION' (state) {
        if (state.monedaId == 102) {
            state.renglones.forEach(renglon => {
                /* Actualizamos el importe neto */
                if (state.monedaId == state.monedaPresupuestoId) {
                    renglon.importeNeto = renglon.importeNetoPresupuesto;
                } else {
                    if (state.monedaId == 102 & state.monedaPresupuestoId == 101) {
                        renglon.importeNeto = roundNumber(parseFloat(renglon.importeNetoPresupuesto) / parseFloat(state.cotizacion), 2);
                    } else {
                        renglon.importeNeto = roundNumber(parseFloat(renglon.importeNetoPresupuesto) * parseFloat(state.cotizacion), 2);
                    }
                }
                /* Actualizamos el importe facturado */
                renglon.importe =  roundNumber(parseFloat(renglon.importeNeto) * parseFloat(renglon.pjeFacturado) / 100, 2);
            });
    
            calcularTotalesRenglones(state);
            setRenglonDescripcion(state);
        }
    },

    'ADD_RENGLON_DESCRIPCION' (state) {
        let renglonesDescripcion = state.renglonesDescripcion.length;
        const renglonDescripcion = {
            renglonNumero: renglonesDescripcion + 1,
            descripcion: '',
            importe: 0,
        }
        state.renglonesDescripcion.push(renglonDescripcion);
    },
    'VALIDAR_RENGLON_DESCRIPCION' (state) {
        validarRenglonesDescripcion(state.renglonesDescripcion);
    },

    'INICIALIZAR_DATOS' (state) {
        state.facturaProformaDatos = [];
        state.facturaProformaRenglonesDatos = [];
        state.facturaProformaRenglonesDescripcionDatos = [];
        state.facturaProformaDatosMoneda = '';
    },
    'SET_FACTURA_DATOS' (state, params) {
        state.facturaProformaDatos = params.facturaProformaDatos;
        state.facturaProformaRenglonesDatos = params.facturaProformaRenglonesDatos;
        state.facturaProformaRenglonesDescripcionDatos = params.facturaProformaRenglonesDescripcionDatos;
        state.facturaProformaDatosMoneda = params.moneda;
    },
    'INICIALIZAR_DATOS_PDF' (state) {
        state.facturaProformaDatosPDF = [];
        state.facturaProformaRenglonesDatosPDF = [];
    },
    'SET_FACTURA_DATOS_PDF' (state, params) {
        state.facturaProformaDatosPDF = params.facturaProformaDatosPDF;
        state.facturaProformaRenglonesDatosPDF = params.facturaProformaRenglonesDatosPDF;
    },

};

function calcularTotalesRenglones(state) {
    let montoGravado = 0;
    let montoExento = 0;
    let montoNoGravado = 0;
    let montoIvaInscripto = 0;

    let montoBase = state.renglones
        .reduce((importe, renglon) => importe + parseFloat(renglon.importe), 0);

    montoBase = roundNumber(montoBase, 2);

    // console.log(montoBase);

    let condicionFiscalId = 0;
    if (state.condicionFiscalId) {
        condicionFiscalId = state.condicionFiscalId;
    }

    switch(condicionFiscalId) {
        case 1: /* Responsable Inscripto */
            montoGravado = montoBase;
            montoIvaInscripto = roundNumber(montoBase * parseFloat(state.pjeIvaInscripto) / 100, 2);
            break;

        case 2: /* Responsable Monotributo */
        case 4: /* Consumidor final */
            montoGravado = montoBase;
            break;
    
        case 3: /* Sujeto del exterior */
            montoExento = montoBase;
            break;
    
        default:
            montoNoGravado = montoBase;
            break;
    }

    // state.total = roundNumber((parseFloat(montoGravado) + parseFloat(montoExento) 
    //     + parseFloat(montoNoGravado) + parseFloat(montoIvaInscripto)) * parseFloat(state.cotizacion), 2);
    state.total = roundNumber(parseFloat(montoGravado) + parseFloat(montoExento) 
        + parseFloat(montoNoGravado) + parseFloat(montoIvaInscripto), 2);
    state.montoGravado = roundNumber(montoGravado, 2);
    state.montoExento = roundNumber(montoExento, 2);
    state.montoNoGravado = roundNumber(montoNoGravado, 2);
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);
    // console.log(state.total);
}

function setRenglonDescripcion(state) {
    state.renglonesDescripcion = [];
    
    state.renglonesDescripcion.push({
            renglonNumero: 1,
            descripcion: '',
            importe: state.montoGravado + state.montoExento + state.montoNoGravado,
            _rowVariant: ''
        })
}

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

function validarRenglonesDescripcion(renglones) {
    let valid = true;
    let descripcion = false
    renglones.forEach(renglon => {
        if (renglon.descripcion.trim() != '') {
            descripcion = true;
        }
        if (isNaN(renglon.importe) || renglon.importe === '') {
            renglon._rowVariant = 'danger';
            valid = false;
        } else {
            renglon._rowVariant = '';
        }
    });
    if (descripcion == false) {
        valid = false;
    }
    return valid;
}

const getters = {
    getField,

    facturaProformaDatosPDF(state) {
        return state.facturaProformaDatosPDF;
    },
    facturaProformaRenglonesDatosPDF(state) {
        return state.facturaProformaRenglonesDatosPDF;
    },
};

const actions = {
    inicializar ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FACTURA', presupuestoId);

            if (presupuestoId != 0) {
                apiAxios.get('facturasproforma/presupuesto/' + presupuestoId ) 
                    .then(res => {
                        commit('SET_FACTURA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let isValid = true;
            let errorMessage = '';
            
            if (parseFloat(state.importe) == 0) {
                isValid = false;
                errorMessage = 'No se puede registrar una factura con importe igual a cero';
            }

            /* Validamos el pje a facturar por cada renglon */
            for (let key in state.renglones){
                const renglon = state.renglones[key];
                if ( parseFloat(renglon.pjeFacturado) > 100 || parseFloat(renglon.pjeFacturado) < 0) {
                    isValid = false;
                    errorMessage = 'El porcentaje a facturar por cada renglon no puede ser superior al 100%.';
                }
            }

            if (!validarRenglonesDescripcion(state.renglonesDescripcion)) {
                isValid = false;
                errorMessage = 'Verifique la información correspondiente a la impresión del comprobante.\n'
                    + 'Al menos un renglón debe contener una descripción, y el importe de cada renglón debe ser un valor numérico'
                    + ' (en caso de no requerir impresión asignarle el valor cero).';
            }

            if (isValid) {
                let renglones = [];
                for (let key in state.renglones){
                    const renglon = state.renglones[key];

                    const renglonFactura = {
                        ordenTrabajoId: parseInt(renglon.ordenTrabajoId),
                        ordenTrabajo: {
                            id: renglon.ordenTrabajoId,
                            nombre: ''
                        },
                        pjeFacturado: parseFloat(renglon.pjeFacturado),
                        importe: parseFloat(renglon.importe)
                    }
                    renglones.push(renglonFactura);
                }
            
                let facturaProforma= {
                    presupuestoInternoId: parseInt(state.presupuestoInternoId),
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    formaPagoId: parseInt(state.formaPagoId),
                    monedaId: parseInt(state.monedaId),
                    cotizacion: parseFloat(state.cotizacion),
                    total: parseFloat(state.total),
                    montoGravado: parseFloat(state.montoGravado),
                    montoExento: parseFloat(state.montoExento),
                    montoNoGravado: parseFloat(state.montoNoGravado),
                    montoIvaInscripto: parseFloat(state.montoIvaInscripto),
                    observaciones: state.observaciones.trim(),
                    renglones: renglones,
                    renglonesDescripcion: state.renglonesDescripcion
                };

                apiAxios.post('facturasproforma', facturaProforma)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    reject(errorMessage);
                }
            })
    },
    setFormaPago: ( { commit }, formaPago) => {
        return new Promise((resolve, reject) => {
            commit('SET_FORMA_PAGO', formaPago);
            resolve();
        })
    },
    setMoneda: ( { commit }, moneda) => {
        return new Promise((resolve, reject) => {
            commit('SET_MONEDA', moneda);
            resolve();
        })
    },
    updatePjeFacturado: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_PJE_FACTURADO_RENGLON', params);
            resolve();
        })
    },
    updateImporteFacturado: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_IMPORTE_RENGLON', params);
            resolve();
        })
    },
    updateCotizacion: ( { commit }) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_COTIZACION');
            resolve();
        })
    },
    addRenglonDescripcion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('ADD_RENGLON_DESCRIPCION');
            resolve();
        })            
    },
    validarRenglonDescripcion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('VALIDAR_RENGLON_DESCRIPCION');
            resolve();
        })            
    },
    getDatos ( { commit }, facturaProformaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (facturaProformaId) {
                apiAxios.get('facturasproforma/' + facturaProformaId ) 
                    .then(res => {
                        let identificacion = `${res.data.documentoTipo} ${res.data.documentoNumero}`;

                        let total = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.total)}`;
                        let montoGravado = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoGravado)}`;
                        let montoExento = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoExento)}`;
                        let montoNoGravado = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoNoGravado)}`;
                        let montoIvaInscripto = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoIvaInscripto)}`;

                        let facturaProformaDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha de Comp.', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            { 'nombre': 'fechaVencimiento', 'campo': 'Fecha de Venc.', 'valor': res.data.fechaVencimiento, 'formato': 'fecha' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'condicionFiscal', 'campo': 'Cond. Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                            { 'nombre': 'identificacion', 'campo': 'Tipo y Cod. Identificación', 'valor': identificacion, 'formato': '' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                            { 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            { 'nombre': 'montoGravado', 'campo': 'Monto Gravado', 'valor': montoGravado, 'formato': '' },
                            { 'nombre': 'montoExento', 'campo': 'Monto Exento', 'valor': montoExento, 'formato': '' },
                            { 'nombre': 'montoNoGravado', 'campo': 'Monto No Gravado', 'valor': montoNoGravado, 'formato': '' },
                            { 'nombre': 'montoIvaInscripto', 'campo': 'Monto Iva Insc.', 'valor': montoIvaInscripto, 'formato': '' },
                            // { 'nombre': 'montoTotal', 'campo': 'Monto Total', 'valor': res.data.montoTotal, 'formato': 'moneda' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        ]

                        if (moment(res.data.fechaAnulado).format('YYYY-MM-DD') != '1900-01-01') {
                            facturaProformaDatos.push({ 'nombre': 'fechaAnulado', 'campo': 'Fecha Anulación', 'valor': res.data.fechaAnulado, 'formato': 'fechaHora' });
                            facturaProformaDatos.push({ 'nombre': 'usuarioAnulado', 'campo': 'Usuario Anulación', 'valor': res.data.usuarioAnulado, 'formato': '' });
                        }

                        var params = {
                            facturaProformaDatos,
                            facturaProformaRenglonesDatos: res.data.renglones,
                            facturaProformaRenglonesDescripcionDatos: res.data.renglonesDescripcion,
                            moneda: res.data.moneda.trim()
                        }
                                      
                        commit('SET_FACTURA_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    getDatosPDF ( { commit }, facturaProformaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS_PDF');

            if (facturaProformaId) {
                apiAxios.get('facturasproforma/' + facturaProformaId ) 
                    .then(res => {
                        let params = {
                            facturaProformaDatosPDF: res.data,
                            facturaProformaRenglonesDatosPDF: res.data.renglonesDescripcion
                        }
                                      
                        commit('SET_FACTURA_DATOS_PDF', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}